import { Component, OnDestroy, OnInit } from '@angular/core';
import { OrderInboxService } from '../service/order-inbox.service';
import { take, tap } from 'rxjs/operators';
import { InboxStateModel } from '../state/model/inbox-state.model';
import { lastValueFrom, Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { QueueModel } from '../model/queues.model';

@Component({
	selector: 'cv-inbox-header',
	templateUrl: './inbox-header.component.html',
	styleUrls: ['./inbox-header.component.scss']
})
export class InboxHeaderComponent implements OnDestroy, OnInit {
	inboxStateModel$: Observable<InboxStateModel> = this.store.select(state => state.intelligence.inbox);
	queues: Array<QueueModel> = [];
	selectedQueues: Array<QueueModel> | undefined = undefined;

	constructor(
		private orderInboxService: OrderInboxService,
		private store: Store
	) {
		this.inboxStateModel$
			.pipe(
				take(1),
				tap((inboxStateModel: InboxStateModel) => {
					if (inboxStateModel && inboxStateModel.inboxFilterForm && inboxStateModel.inboxFilterForm.queues) {
						if (inboxStateModel.inboxFilterForm.queues !== undefined) {
							this.selectedQueues = structuredClone(inboxStateModel.inboxFilterForm.queues);
						}
					}
				})
			)
			.subscribe();
	}

	ngOnInit(): void {
		this.loadQueues();
	}


	/** 
	 * Calls getQueues services verifies if already is any selected queues on stte an if not assigns all queues as default
	*/
	async loadQueues(): Promise<void> {
		try {
			this.queues = await lastValueFrom(this.orderInboxService.getQueues());
			// Validates if there are not any selected queues on state, and by default selects all queues
			if (this.selectedQueues === undefined) {
				this.selectedQueues = structuredClone(this.queues)
				this.orderInboxService.setHeaderInboxData({ applyGlobalFilters: this.selectedQueues || [] });
			} else {
				let tempSelectedQueues = structuredClone(this.selectedQueues);
				const newSelectedQueues = tempSelectedQueues.filter((selectedQueue: QueueModel) => {
					return this.queues.find((loadedQueue: QueueModel) => {
						return loadedQueue.id === selectedQueue.id
					})
				})
				this.selectedQueues = newSelectedQueues;
				this.orderInboxService.setHeaderInboxData({ applyGlobalFilters: this.selectedQueues || [] });
			}
		} catch (error) {
			console.error(error);
		}
	}

	/**
	 * Handle function to manage changes from the multislect component
	 * @param $event 
	 */
	public handleQueueChange($event: any): void {
		this.selectedQueues = structuredClone($event);
		this.orderInboxService.setHeaderInboxData({ applyGlobalFilters: this.selectedQueues || [] });
	}

	/**
	 * Function to validate if the queues variable have at least one object
	 * @returns {boolean}
	 */
	shouldDisplayQueues(): boolean {
		return this.queues.length > 0;
	}

	/**
	 * Calls service to communicate with Inbox component to reload the grid.
	 */
	reloadInbox(): void {
		this.orderInboxService.setHeaderInboxData({ reloadInbox: true });
	}

	/**
	 * onGlobalFilterChange Handler.
	 * @param $event: any
	 */
	onGlobalFilterChange($event: any): void {
		this.orderInboxService.setHeaderInboxData({ applyGlobalFilters: $event || {} });
	}

	ngOnDestroy(): void {
		this.orderInboxService.setHeaderInboxData({});
	}
}
